export default function SentIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M7.125 11.25L12.75 5.625"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00617 5.75916L11.4967 3.16411C13.778 2.08583 14.9187 1.54669 15.6463 2.08756C16.3738 2.62841 16.1659 3.86099 15.7502 6.32614L15.034 10.5726C14.7622 12.1845 14.6263 12.9904 14.0256 13.3418C13.4248 13.6933 12.6445 13.4233 11.0838 12.8835L6.30949 11.2321C3.39079 10.2226 1.93144 9.71782 1.87656 8.72737C1.82167 7.73692 3.2165 7.07769 6.00617 5.75916Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.125 11.625V13.2956C7.125 15.0758 7.125 15.9659 7.65764 16.1078C8.19029 16.2497 8.75122 15.5092 9.87307 14.0279L10.5 13.125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
